import React, { Component } from "react";
import {
  useLocation, // Embora não usado neste snippet, mantido para contexto
  useNavigate, // Embora não usado neste snippet, mantido para contexto
  NavLink, // Embora não usado neste snippet, mantido para contexto
  Outlet, // Embora não usado neste snippet, mantido para contexto
  Navigate, // Embora não usado neste snippet, mantido para contexto
  Link,
} from "react-router-dom";
import InputMask from "react-input-mask"; // Mantido para contexto
import { ToastContainer, toast } from "react-toastify"; // Mantido para contexto
import "react-toastify/dist/ReactToastify.css"; // Mantido para contexto

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCoffee, // Não usado, mas mantido para contexto
  faUser, // Não usado, mas mantido para contexto
  faMagnifyingGlass, // Não usado, mas mantido para contexto
  faBars,
  faShoppingCart, // Não usado, mas mantido para contexto
  faHeart, // Não usado, mas mantido para contexto
} from "@fortawesome/free-solid-svg-icons";

import MyContext from "../../../../../comps/context";

class ItensMenu extends Component {
  static contextType = MyContext; // Declara o contexto para ser usado na classe

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      load: false,
      isCategoriesSidebarOpen: false, // Novo estado para controlar a barra lateral de categorias
    };
    // Refs para o botão e a barra lateral para detectar cliques fora
    this.categoriesSidebarRef = React.createRef();
    this.categoriesButtonRef = React.createRef();

    // Bind this para as funções de evento
    this.toggleCategoriesSidebar = this.toggleCategoriesSidebar.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    fetch(`/_next/api/DataMenu/`)
      .then((response) => response.json())
      .then((data) => {
        this.context.updateVariable(data.ItensCar);
        this.context.setaHistBusca(data.histBusca);
        this.setState({
          load: true,
          data: data,
        });
      });

    // Adiciona o event listener ao montar o componente
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    // Remove o event listener ao desmontar o componente para evitar vazamento de memória
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  toggleCategoriesSidebar() {
    this.setState((prevState) => ({
      isCategoriesSidebarOpen: !prevState.isCategoriesSidebarOpen,
    }));
  }

  handleClickOutside(event) {
    // Se a barra lateral estiver aberta E
    // Se o clique não foi dentro da barra lateral E
    // Se o clique não foi no botão que abre a barra lateral
    if (
      this.state.isCategoriesSidebarOpen &&
      this.categoriesSidebarRef.current &&
      !this.categoriesSidebarRef.current.contains(event.target) &&
      this.categoriesButtonRef.current &&
      !this.categoriesButtonRef.current.contains(event.target)
    ) {
      this.setState({ isCategoriesSidebarOpen: false });
    }
  }

  render() {
    // Filtra as categorias principais que não têm link direto ou são "Carregando..."
    const mainCategories = this.state.data.Categorias?.filter(
      (cat) => cat.titulo !== "Carregando..." && cat.ndi
    );

    return (
      <>
        {this.state.load === false ? (
          <>
            <div className="row align-items-center">
              <div className="col-lg-12 col-md-6 col-12">
                <div className="nav-inner">
                  <div className="mega-category-menu">
                    <a href="https://www.welessa.com/categorias/" data-link="">
                      <span className="cat-button">
                        <FontAwesomeIcon icon={faBars} />
                        Todas categorias
                      </span>
                    </a>
                    <ul className="sub-category">
                      <li
                        style={{
                          display: "table",
                          margin: "auto",
                        }}
                      >
                        Carregando...
                      </li>
                    </ul>
                  </div>
                  <nav className="navbar navbar-expand-lg">
                    <button
                      className="navbar-toggler mobile-menu-btn"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#navbarSupportedContent"
                      aria-controls="navbarSupportedContent"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                    >
                      <span className="toggler-icon"></span>
                      <span className="toggler-icon"></span>
                      <span className="toggler-icon"></span>
                    </button>
                    <div
                      className="collapse navbar-collapse sub-menu-bar"
                      id="navbarSupportedContent"
                    >
                      <ul id="nav" className="navbar-nav ms-auto ajusta-loader">
                        <li
                          className="nav-item load"
                          style={{
                            width: 130,
                            height: 16,
                          }}
                        ></li>

                        <li
                          className="nav-item load"
                          style={{
                            width: 130,
                            height: 16,
                          }}
                        ></li>

                        <li
                          className="nav-item load"
                          style={{
                            width: 130,
                            height: 16,
                          }}
                        ></li>

                        <li
                          className="nav-item load"
                          style={{
                            width: 130,
                            height: 16,
                          }}
                        ></li>
                      </ul>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="row align-items-center">
              <div className="col-lg-12 col-md-6 col-12">
                <div className="nav-inner">
                  <div className="mega-category-menu">
                    {/* Botão que abre a barra lateral de categorias */}
                    <button
                      ref={this.categoriesButtonRef} // Referência para o botão
                      onClick={this.toggleCategoriesSidebar}
                      style={{ background: "transparent", border: "none" }}
                    >
                      <span className="cat-button">
                        <FontAwesomeIcon icon={faBars} />
                        Todas categorias
                      </span>
                    </button>
                  </div>
                  <nav className="navbar navbar-expand-lg">
                    <button
                      className="navbar-toggler mobile-menu-btn"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#navbarSupportedContent"
                      aria-controls="navbarSupportedContent"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                    >
                      <span className="toggler-icon"></span>
                      <span className="toggler-icon"></span>
                      <span className="toggler-icon"></span>
                    </button>
                    <div
                      className="collapse navbar-collapse sub-menu-bar"
                      id="navbarSupportedContent"
                    >
                      <ul id="nav" className="navbar-nav ms-auto">
                        {this.state.data.Sgt?.map((item, index) => (
                          <li className="nav-item" key={index}>
                            <Link to={"/categoria/" + item.ndi}>
                              {item.titulo}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </nav>
                </div>
              </div>
            </div>

            {/* Barra Lateral de Categorias */}
            <div
              id="categories-sidebar"
              ref={this.categoriesSidebarRef} // Referência para a barra lateral
              className={`categories-sidebar ${
                this.state.isCategoriesSidebarOpen ? "open" : ""
              }`}
            >
              <div className="categories-sidebar-header">
                <h3>Categorias</h3>
                <button
                  onClick={this.toggleCategoriesSidebar}
                  className="close-btn"
                >
                  &times;
                </button>
              </div>
              <div className="categories-sidebar-body">
                {this.state.data.Categorias?.length > 0 ? (
                  <ul>
                    {mainCategories?.map((item, index) => (
                      <li key={index}>
                        <Link
                          to={`/categoria/${item.ndi}`}
                          onClick={this.toggleCategoriesSidebar}
                        >
                          {item.titulo}
                        </Link>
                        {item.subcategorias &&
                          item.subcategorias.length > 0 && (
                            <ul className="sub-categories-list">
                              {item.subcategorias.map((subItem, subIndex) => (
                                <li key={subIndex}>
                                  <Link
                                    to={`/categoria/${subItem.ndi}`}
                                    onClick={this.toggleCategoriesSidebar}
                                  >
                                    {subItem.titulo}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          )}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>Nenhuma categoria disponível.</p>
                )}
              </div>
            </div>

            {/* Overlay */}
            {this.state.isCategoriesSidebarOpen && (
              <div
                className="categories-overlay"
                onClick={this.toggleCategoriesSidebar}
              ></div>
            )}
          </>
        )}
      </>
    );
  }
}
ItensMenu.contextType = MyContext; // Garante que o contexto esteja disponível
export default ItensMenu;
